<template>
  <app-confirm-dialog
    v-model="dialog"
    @confirm="confirm"
    @cancel="cancel"
    confirmBtnText="邀請分享"
    cancelBtnText="取消"
    maxWidth="320"
    :loading="loading"
    :showConfirmBtn="showConfirmBtn"
    :showCancelBtn="showCancelBtn">
    <span class="subheading">{{dialogText}}</span>
    <template slot="action">
      <v-btn
        v-show="showCancelInvtieBtn"
        @click="cancelInvite"
        flat>
        取消邀請
      </v-btn>
    </template>
  </app-confirm-dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {FudaoEvent, fudaoAppService} from 'langyan';

const getDefaultData = () => {
  return {
    loading: false,
    dialog: false,
    dialogText: '',
    showConfirmBtn: true,
    showCancelBtn: true,
    showCancelInvtieBtn: false,
    sessionType: null,
    fudaoSession: {}
  };
};

export default {
  data: getDefaultData,
  computed: {
    ...mapState('fudao', {
      fudaoId: state => state.fudaoDto.id,
      responseTimeout: state => state.responseTimeout
    })
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.reset();
      }
    }
  },

  mounted() {
  },

  beforeDestory() {
    this.reset();
  },

  methods: {
    ...mapActions('alert', {
      addAlert: 'add'
    }),

    isDifferentFudao(domainEvent) {
      return this.fudaoId !== domainEvent.entityId;
    },

    open(sessionType) {
      if (!this.fudaoId) {
        return;
      }

      // sessionType was definied in FudaoDefinition.ts
      switch (sessionType) {
        case 'TeacherVideo':
          this.dialogText = '是否要邀請視訊分享?';
          break;

        case 'Audio':
          this.dialogText = '是否要邀請音訊分享?';
          break;

        case 'Whiteboard':
          this.dialogText = '是否要邀請白板分享?';
          break;
      }
      this.sessionType = sessionType;
      this.dialog = true;
    },

    reset() {
      this.$eventBus.$off(FudaoEvent.StudentStartSessionInvitationAccepted, this.onStudentStartSessionInvitationAccepted);
      this.$eventBus.$off(FudaoEvent.StudentStartSessionInvitationRejected, this.onStudentStartSessionInvitationRejected);
      this.$eventBus.$off(FudaoEvent.StudentStartSessionInvitationNoReponse, this.onStudentStartSessionInvitationNoReponse);
      this.$eventBus.$off(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);
      this.$eventBus.$off(FudaoEvent.FudaoSessionStarted, this.onFudaoSessionStarted);

      clearTimeout(this._timeout);
      let data = getDefaultData();
      Object.keys(data).forEach(key => this[key] = data[key]);
    },

    async confirm() {
      this.loading = true;
      this.$eventBus.$on(FudaoEvent.StudentStartSessionInvitationAccepted, this.onStudentStartSessionInvitationAccepted);
      this.$eventBus.$on(FudaoEvent.StudentStartSessionInvitationRejected, this.onStudentStartSessionInvitationRejected);
      this.$eventBus.$on(FudaoEvent.StudentStartSessionInvitationNoReponse, this.onStudentStartSessionInvitationNoReponse);
      this.$eventBus.$on(FudaoEvent.FudaoSessionFailed, this.onFudaoSessionFailed);
      this.$eventBus.$on(FudaoEvent.FudaoSessionStarted, this.onFudaoSessionStarted);

      switch (this.sessionType) {
        case 'TeacherVideo':
          this.fudaoSession = await fudaoAppService.inviteFudaoVideoChatAsync(this.fudaoId);
          break;

        case 'Audio':
          this.fudaoSession = await fudaoAppService.inviteFudaoAudioChatAsync(this.fudaoId);
          break;

        case 'Whiteboard':
          this.fudaoSession = await fudaoAppService.inviteFudaoWhiteboardAsync(this.fudaoId);
          break;
      }

      this.dialogText = '已送出邀請，等待對方回應...';
      this.showConfirmBtn = false;
      this.showCancelBtn = false;
      this.showCancelInvtieBtn = true;

      this._timeout = setTimeout(() => {
        this.sentNoResponse();
      }, this.responseTimeout);
    },

    cancel() {
      this.dialog = false;
    },

    async cancelInvite() {
      clearTimeout(this._timeout);
      await fudaoAppService.cancelFudaoStartSessionInvitionAsync(this.fudaoId, this.fudaoSession);
      this.dialog = false;
    },

    sentNoResponse() {
      fudaoAppService.noResponseFudaoStartSessionInvitionAsync(this.fudaoId, this.fudaoSession);
    },

    // events -------------------------------------

    async onStudentStartSessionInvitationAccepted(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      let containerElm;
      clearTimeout(this._timeout);
      switch (this.sessionType) {
        case 'TeacherVideo':
          containerElm = document.getElementById('fudaoVideo');
          await fudaoAppService.startFudaoSessionAsync(this.fudaoId, domainEvent.body, containerElm);
          break;

        case 'Audio':
          await fudaoAppService.startFudaoSessionAsync(this.fudaoId, domainEvent.body);
          break;

        case 'Whiteboard':
          containerElm = document.getElementById('fudaoWhiteboard');
          await fudaoAppService.startFudaoSessionAsync(this.fudaoId, domainEvent.body, containerElm);
          break;
      }
    },

    onStudentStartSessionInvitationRejected(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'info', content: '學生拒絕邀請'});
      this.dialog = false;
    },

    onStudentStartSessionInvitationNoReponse(domainEvent) {
      if (this.isDifferentFudao(domainEvent)) {
        return;
      }
      this.addAlert({level: 'warning', content: '邀請分享無回應'});
      this.dialog = false;
    },

    onFudaoSessionFailed(errMsg) {
      this.addAlert({level: 'error', content: '邀請分享發生錯誤'});
      this.dialog = false;
    },

    onFudaoSessionStarted(domainEvent) {
      this.dialog = false;
    }
  }
};
</script>